var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPridat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3165_12966)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 0.5C8.61819 0.5 8.91667 0.798477 8.91667 1.16667V7.83333H15.5833C15.9515 7.83333 16.25 8.13181 16.25 8.5C16.25 8.86819 15.9515 9.16667 15.5833 9.16667H8.91667V15.8333C8.91667 16.2015 8.61819 16.5 8.25 16.5C7.88181 16.5 7.58333 16.2015 7.58333 15.8333V9.16667H0.916667C0.548477 9.16667 0.25 8.86819 0.25 8.5C0.25 8.13181 0.548477 7.83333 0.916667 7.83333H7.58333V1.16667C7.58333 0.798477 7.88181 0.5 8.25 0.5Z",
    fill: "#2362A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3165_12966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.25 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPridat);
export default __webpack_public_path__ + "static/media/icon_pridat.0b351fb633795c1a7fbda95dac2e4deb.svg";
export { ForwardRef as ReactComponent };